import PullRequestForm from "@/modules/pull-requests/form";
import React from "react";
import { EvtHeader } from "components/header";

const CreatePullRequest = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Pull Request" />
      <div className="max-w-md p-4 lg:p-6">
        <PullRequestForm />
      </div>
    </div>
  );
};

export default CreatePullRequest;
